import React, { createContext, useContext, useState, useMemo } from "react";

const translations = {
  en: {
    brand: "Grupo Estrella Hernández Inversiones",
    tagline: "Your financial backing, your safe growth",
    nav_home: "Home",
    nav_calculator: "Loan Calculator",
    nav_rates: "Our Rates",
    login: "Log In",
    register: "Join Now",
    logout: "Log Out",
    dashboard: "Dashboard",
    admin_panel: "Admin Panel",
    hero_title: "Grow your money with a partner that grows with you",
    hero_sub: "Savings and investment accounts with real yearly returns, fair loans, and a team that puts its clients first.",
    hero_cta: "Open an account",
    hero_cta2: "Try the loan calculator",
    feat_savings_t: "Savings Accounts",
    feat_savings_d: "Earn accrued interest every second, calculated on your real balance and time.",
    feat_shares_t: "Share Accounts",
    feat_shares_d: "Become an owner and earn yearly returns on your participation shares.",
    feat_loans_t: "Fair Loans",
    feat_loans_d: "Transparent amortization with clear monthly payments and no hidden fees.",
    rates_title: "Current Annual Rates",
    savings_rate: "Savings Yield",
    shares_rate: "Shares Yield",
    per_year: "per year",
    calc_title: "Loan Amortization Calculator",
    calc_sub: "Estimate your monthly payment and total cost instantly.",
    amount: "Loan Amount",
    rate: "Annual Interest Rate (%)",
    term: "Term (months)",
    calculate: "Calculate",
    monthly_payment: "Monthly Payment",
    total_interest: "Total Interest",
    total_payment: "Total to Pay",
    loans_tab: "Loans",
    loan_request_tab: "Request a Loan",
    activity_tab: "Activity",
    loan_applications_tab: "Loan Requests",
    twofa_yes: "2FA on",
    twofa_no: "No 2FA",
    loans_registry: "Loans Registry",
    new_loan: "New Loan",
    edit_loan: "Edit Loan",
    loan_number: "Loan No.",
    loan_amount_label: "Loan Amount",
    interest_rate: "Interest Rate",
    term_months: "Term (months)",
    amortization: "Amortization Schedule",
    months_unit: "months",
    view_schedule: "View schedule",
    confirm_delete_loan: "Delete this loan?",
    schedule: "Amortization Schedule",
    period: "#",
    payment: "Payment",
    principal: "Principal",
    interest: "Interest",
    balance: "Balance",
    // auth
    welcome_back: "Welcome back",
    login_sub: "Log in with your email or phone number",
    email_or_phone: "Email or phone number",
    password: "Password",
    create_account: "Create your account",
    register_sub: "Sign up in a minute",
    full_name: "Full name",
    email: "Email",
    phone: "Phone number",
    optional: "optional",
    no_account: "Don't have an account?",
    have_account: "Already a member?",
    // client dashboard
    hello: "Hello",
    my_accounts: "My Accounts",
    my_profile: "My Profile",
    current_balance: "Current balance",
    accrued_earnings: "Accrued earnings",
    annual_rate: "Annual rate",
    no_accounts: "You don't have any accounts yet. Contact the administration to open one.",
    recent_activity: "Recent Activity",
    no_activity: "No transactions yet.",
    type: "Type",
    date: "Date",
    // account types
    savings: "Savings",
    shares: "Shares",
    loan: "Loan",
    deposit: "Deposit",
    withdraw: "Withdraw",
    transfer_in: "Transfer received",
    transfer_out: "Transfer sent",
    raffle_refund: "Ticket refund",
    raffle_purchase: "Ticket purchase",
    mv_amount: "Amount",
    invalid_amount: "Enter a valid amount",
    withdrawal: "Withdrawal",
    // admin
    clients: "Clients",
    manage_rates: "Manage Rates",
    total_clients: "Total Clients",
    total_savings: "Total Savings",
    total_shares: "Total Shares",
    active_loans: "Active Loans",
    search_client: "Search client...",
    member_since: "Member since",
    add_account: "Add account",
    account_type: "Account type",
    filter_all_members: "All",
    filter_no_savings: "No savings",
    filter_no_shares: "No shares",
    filter_no_loan: "No loan",
    no_clients_found: "No members found",
    sort_name: "Name (A–Z)",
    sort_recent: "Newest first",
    sort_oldest: "Oldest first",
    prev: "Previous",
    next: "Next",
    view: "Manage",
    open_account: "Open Account",
    create_loan: "Create Loan",
    save: "Save",
    cancel: "Cancel",
    update_rates: "Update Rates",
    rates_updated: "Rates updated successfully",
    exchange_rate: "Exchange Rate (RD$ per US$1)",
    exchange_hint: "Used to show approximate values in the other currency.",
    approx: "approx.",
    folio: "Folio",
    verify_deposit: "Verify a Certificate",
    verify_sub: "Enter the folio or account number of a term-deposit certificate to verify its authenticity.",
    verify_placeholder: "Folio or account number",
    verify_btn: "Verify",
    verify_valid: "Valid certificate",
    verify_download: "Download original document",
    verify_invalid: "No certificate found with that folio or account number.",
    verify_savings: "Savings account",
    verify_balance: "Balance",
    nav_verify: "Verify Certificate",
    total_dop: "Total in RD$",
    total_usd: "Total in US$",
    rate_history: "Change History",
    no_history: "No changes recorded yet.",
    changed_by: "Changed by",
    link_client: "Link to client",
    linked: "Linked",
    linked_by: "Linked by",
    select_client: "Select a client",
    no_link: "No link",
    download_overview: "Download summary (PDF)",
    growth_title: "Projected growth (12 months)",
    growth_sub: "Estimated value of your savings, shares and term deposits over the next year (in RD$).",
    projected_value: "Projected value",
    maturity_notice_days: "Auto-notice days before maturity",
    download_excel: "Download (Excel)",
    last_notice: "Last notice",
    pending_only: "Pending only",
    capital_tab: "Capital",
    capital_title: "Capital & Funds",
    capital_load_error: "Could not load capital data",
    retry: "Retry",
    capital_contributed: "Capital contributed",
    growth: "Growth",
    growth_amount: "Growth",
    loans_out: "Loans disbursed",
    loans_collected: "Collected",
    savings_balance_total: "Savings held",
    add_capital: "Add Capital",
    deduct_capital: "Deduct Capital",
    capital_movement: "Capital Movement",
    capital_added_ok: "Capital added",
    capital_deducted_ok: "Capital deducted",
    client_photo: "Client Photo",
    national_id: "ID / National ID",
    national_id_ph: "e.g. 001-1234567-8",
    edit_profile: "Edit profile",
    profile_updated: "Profile updated",
    city: "City",
    date_of_birth: "Date of birth",
    occupation: "Occupation",
    internal_notes: "Internal notes",
    internal_notes_ph: "Private admin notes (not visible to the member)",
    save_changes: "Save changes",
    personal_info: "Personal information",
    name_required: "Name is required",
    change_history: "Change history",
    no_changes_yet: "No changes recorded yet.",
    changed_field: "changed",
    remove_photo: "Remove photo",
    profile_photo: "Profile photo",
    birthdays_tab: "Birthdays",
    birthdays_of: "Birthdays in",
    no_birthdays: "No members with a birthday this month.",
    turns_years: "turns",
    carousel_tab: "Carousel & Notices",
    manage_carousel: "Carousel & notices",
    carousel_hint: "Up to 3 slides. Members will see these on their account.",
    slide: "Slide",
    add_slide: "Add slide",
    remove_slide: "Remove slide",
    slide_image: "Image",
    slide_title: "Title",
    slide_text: "Text",
    button_text: "Button text",
    button_link: "Button link (optional)",
    assign_person: "Assign a person",
    assigned_person: "Assigned person",
    remove_person: "Remove person",
    none_option: "— None —",
    announcements: "Announcements",
    add_announcement: "Add announcement",
    no_announcements: "No announcements.",
    news_for_you: "News for you",
    max_slides: "Maximum 3 slides",
    btn_target: "Button destination",
    btn_target_url: "External link (URL)",
    btn_target_events: "Social Events (Calendar)",
    team_tab: "Our Team",
    manage_team: "Our Team / Board",
    team_hint: "People shown to members (photo, name and role).",
    add_member: "Add person",
    member_role: "Role / position",
    no_team: "No team members yet.",
    confirm_remove: "Remove this item?",
    confirm_remove_person: "Remove this person?",
    move_up: "Move up",
    move_down: "Move down",
    event_capacity: "Capacity",
    spots_left: "spots left",
    event_full: "Full",
    attend: "Attend",
    attending: "You're attending",
    cancel_attend: "Cancel attendance",
    attendees: "attendees",
    view_attendees: "View attendees",
    no_attendees: "No attendees yet.",
    demographics_tab: "Demographics",
    by_city: "By city",
    by_occupation: "By occupation",
    members_count: "members",
    our_board: "Our Board",
    our_board_sub: "People committed to the growth of GEHI.",
    active_members: "Most active members (events)",
    link_member: "Link to member",
    link_member_hint: "Once linked, the account will appear in that member's profile.",
    member: "Member",
    link_accounts: "Link accounts",
    unlinked_accounts: "Unlinked accounts",
    no_unlinked: "No unlinked accounts.",
    link_here: "Link here",
    needs_review: "Review: no match",
    suggested: "Suggested",
    link_selected: "Link selected",
    link_matches: "Link matches",
    link_history_title: "Linking history",
    whatsapp_settings: "WhatsApp / Twilio",
    whatsapp_hint: "Enter your Twilio credentials to send WhatsApp notices to members. It activates when you turn on the switch.",
    whatsapp_test: "Send test",
    whatsapp_test_ok: "Test message sent",
    whatsapp_test_needs_save: "Enable and save WhatsApp first",
    refresh: "Refresh",
    notifications_tab: "Notification log",
    notif_log_tab: "Notification log",
    notifications_hint: "Record of every email and WhatsApp the platform has sent, with delivery status.",
    notif_all_channels: "All channels",
    notif_all_status: "All statuses",
    notif_email: "Email",
    notif_sent: "Sent",
    notif_failed: "Failed",
    notif_skipped: "Skipped",
    notif_channel_col: "Channel",
    notif_to: "Recipient",
    notif_subject: "Subject / message",
    notif_status_col: "Status",
    notif_date: "Date",
    notif_resend: "Resend",
    notif_resent: "Message re-sent",
    notif_records: "records",
    notif_stats_title: "Deliveries in the last 7 days",
    whatsapp_sandbox_title: "Using the Twilio Sandbox?",
    whatsapp_sandbox_hint: "To test for free, use the Sandbox number whatsapp:+14155238886 as the origin, and first send 'join <your-code>' from your WhatsApp to that number to activate it. Then set your number below and press Send test.",
    enable_whatsapp: "Enable WhatsApp sending",
    twilio_sid: "Twilio Account SID",
    twilio_token: "Twilio Auth Token",
    whatsapp_from: "WhatsApp sender number",
    admin_whatsapp: "Admin WhatsApp (optional)",
    photo_saved: "Photo saved",
    upload_photo: "Upload Photo",
    replace_photo: "Replace Photo",
    documents: "Documents",
    documents_hint: "Upload ID card and supporting documents (image or PDF)",
    document_label: "Description",
    document_label_ph: "e.g. ID card, proof of income...",
    document_uploaded: "Document uploaded",
    no_documents: "No documents yet",
    view_document: "View document",
    upload: "Upload",
    note: "Note",
    by: "By",
    manage_content_tab: "Content",
    perm_manage_content: "Edit landing content",
    landing_content: "Home Page Content",
    block_win: "Window",
    block_title: "Title",
    block_text: "Message / News",
    block_image: "Photo",
    upload_image: "Upload photo",
    uploading: "Uploading…",
    save_content: "Save content",
    content_saved: "Content saved",
    savings_goal: "Savings goal (RD$)",
    set_goal: "Save goal",
    goal_saved: "Goal saved",
    goal_line: "Goal",
    news_title: "News & Announcements",
    add_window: "Add window",
    remove_window: "Remove",
    move_up: "Move up",
    move_down: "Move down",
    visible: "Visible",
    button_text: "Button text (optional)",
    button_link: "Button link (optional)",
    goal_progress: "Goal progress",
    of_goal: "of your goal",
    referral_tab: "Referrals",
    referral_title: "Referral Program",
    referral_config: "Level Amounts",
    lvl2_amount: "Level 2 amount (total)",
    lvl3_amount: "Level 3 amount (total)",
    lvl4_amount: "Level 4 amount (total)",
    per_person: "per person",
    transfer: "Transfer",
    transfer_recipient: "Recipient (account #, email or phone)",
    transfer_recipient_ph: "e.g. AH-1234567890 or email",
    transfer_need_recipient: "Enter the recipient",
    transfer_recipient_not_found: "No matching account (same currency)",
    transfer_to: "You will transfer to",
    transfer_amount_label: "Amount",
    transfer_continue: "Continue",
    transfer_confirm: "Confirm transfer",
    transfer_done: "Transfer completed",
    insufficient_funds: "Insufficient funds",
    ref_currency: "Currency",
    ref_active: "Payouts active",
    ref_tree: "Referral tree",
    ref_report: "Earnings by member",
    place_client: "Place a client",
    select_sponsor: "Sponsor (optional)",
    ref_link: "Your referral link",
    copy: "Copy",
    copied: "Copied",
    my_network: "My network",
    referral_earnings: "Referral earnings",
    bonus_pending: "Pending bonus",
    bonus_pending_hint: "Qualified — will be credited after 3 months in the account",
    bonus_waiting: "Awaiting qualification",
    bonus_waiting_hint: "Credited once your referral opens an account with over RD$1,000",
    bonus_payable_at: "Payment date",
    bonus_status_paid: "Paid",
    bonus_status_pending: "Pending",
    bonus_status_waiting: "Awaiting",
    status: "Status",
    join_plan: "Join the referral plan",
    not_in_tree: "You are not in the referral tree yet.",
    active_tree: "Active tree",
    completed_tree: "Completed tree",
    confirm_delete_savings: "Delete this savings account?",
    empty_slot: "Empty",
    member: "Member",
    place: "Place",
    ref_saved: "Referral settings saved",
    invited_note: "A member invited you — sign up to join their network.",
    invite_earn_title: "Invite & Earn",
    invite_earn_sub: "Bring your friends and family to GEHI and earn real rewards for every person who joins your network.",
    invite_earn_upto: "Earn up to",
    invite_earn_per: "per referral",
    invite_earn_p1: "Share your personal invite link",
    invite_earn_p2: "They sign up and start saving",
    invite_earn_p3: "You earn bonuses credited to your account",
    invite_earn_cta: "Start earning",
    calc_title: "Referral calculator",
    calc_sub: "See how much you could earn by inviting friends.",
    calc_friends: "Friends you invite",
    calc_you_earn: "You could earn",
    calc_full: "Full network for this cycle!",
    calc_disclaimer: "Estimate based on the current referral plan. Real bonuses depend on your network's activity.",
    calc_share_wa: "Share on WhatsApp",
    calc_share_msg: "I'm inviting friends to Grupo Estrella Hernández Inversiones and I'm already at {n}. Join with my link and let's grow together 💚",
    install_app: "Install app",
    onboarding_title: "Welcome to Grupo Estrella Hernández Inversiones!",
    onboarding_sub: "Here are a few quick things to get you started.",
    onboarding_step_accounts: "Review your accounts and balances",
    onboarding_step_goal: "Set your savings goal",
    onboarding_step_raffle: "Join the weekly raffle",
    onboarding_step_referral: "Invite friends and earn bonuses",
    onboarding_skip: "Skip for now",
    onboarding_done: "Got it, let's go",
    testimonials_tab: "Testimonials",
    manage_testimonials: "Member testimonials",
    testimonials_hint: "Real member stories shown on the public landing page.",
    add_testimonial: "Add testimonial",
    no_testimonials: "No testimonials yet. Add the first one.",
    testimonial_quote: "Testimonial",
    how_title: "How it works",
    how_sub: "Becoming a member and growing your money takes just a few steps.",
    how_s1_t: "Sign up",
    how_s1_d: "Create your account in minutes with your ID.",
    how_s2_t: "Open your savings",
    how_s2_d: "Start saving from small amounts, at your pace.",
    how_s3_t: "Grow your money",
    how_s3_d: "Earn real interest and access fair loans.",
    how_s4_t: "Take part & win",
    how_s4_d: "Join the weekly raffle and the referral program.",
    testimonials_title: "What our clients say",
    testimonials_sub: "Real stories from people who grow with GEHI.",
    rating_based_on: "based on {n} member reviews",
    faq_tab: "FAQ",
    notifications_tab: "Notifications",
    manage_faq: "Frequently asked questions",
    faq_hint: "Questions and answers shown on the public landing page.",
    add_faq: "Add question",
    no_faq: "No questions yet. Add the first one.",
    faq_question: "Question",
    faq_answer: "Answer",
    whatsapp_config_title: "Contact WhatsApp",
    whatsapp_config_hint: "Number for the floating WhatsApp button on the landing (with country code).",
    whatsapp_number_label: "WhatsApp number",
    whatsapp_message_label: "Pre-filled message (optional)",
    faq_title: "Frequently asked questions",
    faq_sub: "Everything you need to know before joining.",
    whatsapp_float: "Chat on WhatsApp",
    whatsapp_default_msg: "Hi, I'd like information to become a member of Grupo Estrella Hernández Inversiones.",
    member_testimonial_title: "Share your experience",
    member_testimonial_sub: "Tell us your story. Once approved, it may appear on our public page.",
    your_testimonial: "Your testimonial",
    testimonial_role_optional: "Title (optional)",
    testimonial_placeholder: "What do you value most about GEHI?",
    submit_testimonial: "Submit testimonial",
    testimonial_thanks: "Thank you! Your testimonial is pending review.",
    testimonial_min: "Please write at least 10 characters.",
    testimonial_pending: "Pending review",
    testimonial_published: "Published",
    approve_testimonial: "Approve",
    status_pending: "pending",
    status_approved: "Approved",
    member_badge: "Member",
    visible: "Visible",
    hidden: "Hidden",
    referral_code_label: "Referral link or code",
    referral_code_ph: "Paste the link or code (e.g. ABC123)",
    referral_detected: "Referral code detected",
    referral_checking: "Checking code…",
    referred_by: "Referred by",
    referral_invalid: "Referral code not found",
    referral: "Referral",
    level: "Level",
    savings_tab: "Savings Accounts",
    savings_accounts: "Savings Accounts",
    new_savings: "New savings account",
    save: "Save",
    account_opened: "Account opened",
    tx_done: "Transaction completed",
    loan_created: "Loan created",
    principal_amount: "Principal amount",
    monthly: "Monthly",
    accounts: "Accounts",
    actions: "Actions",
    client: "Client",
    manage_client: "Manage client",
    currency: "Currency",
    usd: "US Dollars (USD)",
    dop: "Dominican Pesos (RD$)",
    staff: "Staff",
    manage_staff_tab: "Staff & Roles",
    new_employee: "New Employee",
    employees: "Employees",
    role: "Role",
    permissions: "Permissions",
    role_template: "Predefined role",
    custom: "Custom permissions",
    none_template: "None (custom only)",
    tmpl_cajero: "Teller (deposits/withdrawals)",
    tmpl_oficial_credito: "Loan Officer (loans)",
    tmpl_gerente: "Manager (all operations)",
    perm_view_clients: "View clients & balances",
    perm_manage_accounts: "Open savings/shares accounts",
    perm_manage_transactions: "Register deposits & withdrawals",
    perm_manage_loans: "Create loans",
    perm_manage_rates: "Change rates (%)",
    perm_manage_staff: "Manage staff & permissions",
    create_employee: "Create Employee",
    branch_name: "Branch",
    branch_optional: "Branch (optional)",
    collected_by_branch: "By branch (today)",
    ranking_tab: "Branch Ranking",
    branch_ranking_title: "Branch Ranking of the Month",
    branch_ranking_desc: "Total collected per branch (loans + savings + term deposits), converted to RD$.",
    ranking_month: "Month",
    ranking_total_collected: "Total collected this month",
    ranking_movements: "movements",
    ranking_empty: "No collections recorded for this month yet.",
    my_position_title: "Your rank this month",
    pos_you_are: "You're",
    pos_of: "of",
    pos_collected: "collected this month",
    pos_gap_pre: "You need",
    pos_gap_post: "to catch up with",
    pos_leader: "You're leading this month!",
    raffle_tab: "Raffle",
    raffle_title: "Weekly Raffle",
    raffle_desc: "Every deposit or payment gives the member a Powerball-style ticket. Draw runs each Sunday.",
    raffle_settings: "Settings",
    raffle_enable: "Enable raffle",
    raffle_prize: "Prize",
    raffle_auto_draw: "Automatic draw",
    raffle_auto_hint: "If on, the winner is drawn automatically at the scheduled date & time below",
    raffle_draw_datetime: "Draw date & time",
    raffle_draw_datetime_hint: "Pick the exact date and time (RD/AST). It runs automatically and reschedules to the next week. Draw fires at the top of the hour on/after this time.",
    raffle_this_week: "This week",
    raffle_tickets_count: "tickets generated",
    raffle_draw_now: "Draw now",
    raffle_confirm_draw: "Draw the winner for this week now?",
    raffle_winner: "Winner",
    raffle_winning_numbers: "Winning numbers",
    raffle_past_draws: "Past draws",
    raffle_my_tickets: "My tickets this week",
    raffle_week: "Week",
    raffle_no_tickets: "You have no tickets yet. Make a deposit or payment to get one!",
    raffle_you_won: "You won the weekly raffle!",
    raffle_last_winner: "Last winner",
    raffle_off: "The raffle is not active right now.",
    raffle_per_amount: "Tickets per amount (0 = 1 per transaction)",
    raffle_per_amount_hint: "e.g. 1000 gives 1 ticket per RD$1,000 deposited (max 50)",
    raffle_download: "Download ticket",
    raffle_notify_whatsapp: "Notify by WhatsApp",
    raffle_multipliers: "Tickets per product (multiplier)",
    raffle_multipliers_hint: "Multiply the tickets for each product type (e.g. 2 = double)",
    raffle_mult_savings: "Savings",
    raffle_mult_term: "Term",
    raffle_mult_loan: "Loans",
    raffle_sources: "Active areas (ticket sources)",
    raffle_sources_hint: "Turn off an area so deposits/payments there stop generating tickets (anti-fraud)",
    raffle_paid_enable: "Charge for tickets",
    raffle_paid_hint: "Let members buy extra tickets, deducted from their savings balance.",
    raffle_ticket_price: "Price per ticket",
    raffle_paid_max: "Max tickets per purchase",
    raffle_buy_title: "Buy tickets",
    raffle_buy_hint: "Price per ticket",
    raffle_buy_max: "Max per purchase",
    raffle_buy_qty: "Quantity",
    raffle_buy_account: "Pay from",
    raffle_buy_total: "Total",
    raffle_buy_btn: "Buy",
    raffle_buy_no_account: "You don't have a savings account in the ticket currency.",
    raffle_bought: "You bought",
    raffle_pick_account: "Select an account",
    raffle_paid: "Purchased",
    raffle_receipt_ready: "Receipt ready",
    raffle_download_receipt: "Download receipt",
    raffle_weekly_max: "Max per week (0 = unlimited)",
    raffle_weekly_left: "left this week",
    raffle_my_purchases: "My purchases",
    raffle_admin_purchases: "Ticket purchases",
    raffle_refund_btn: "Refund",
    raffle_refunded: "Refunded",
    raffle_confirm_refund: "Refund this purchase and return the balance to the member?",
    raffle_revenue_title: "Ticket sales revenue",
    raffle_revenue_total: "Total collected",
    raffle_revenue_by_week: "By week",
    raffle_revenue_by_branch: "By branch",
    raffle_src_savings: "Savings accounts",
    raffle_src_term: "Term deposits",
    raffle_src_loan: "Loan payments",
    raffle_countdown_pre: "Only",
    raffle_countdown_post: "left until Sunday's draw",
    raffle_today: "The draw is today! Good luck 🍀",
    raffle_drawn_done: "Draw completed ✓ — see the winner below",
    raffle_exact_prize: "Exact prize (no rollover)",
    raffle_exact_hint: "If on, the prize is always exactly the amount you type; nothing accumulates.",
    raffle_exact_active: "Exact prize",
    raffle_day: "day",
    raffle_days: "days",
    winners_title: "Weekly Raffle Winners",
    winners_sub: "Every deposit or payment earns tickets. These are our recent lucky winners!",
    winners_week: "Week",
    raffle_download_all: "Download all",
    raffle_participation: "Participation by branch",
    raffle_participation_tickets: "tickets",
    raffle_mark_claimed: "Mark delivered",
    raffle_claimed: "Delivered",
    raffle_no_winner: "No winner (rolled over)",
    raffle_no_winner_toast: "No exact match this week — prize rolls over",
    raffle_rollover: "Accumulated prize",
    raffle_pot: "This week's prize",
    raffle_rollover_weeks: "accumulating for weeks",
    raffle_secondary_prizes: "Minor prizes (partial match)",
    raffle_secondary_hint: "2nd prize: 4 white + red · 3rd prize: 3 white + red (0 = off)",
    raffle_prize4: "2nd prize (4 white + red)",
    raffle_prize3: "3rd prize (3 white + red)",
    raffle_minor_winners: "Minor winners",
    raffle_seniority: "Tickets by seniority",
    raffle_seniority_hint: "Extra tickets based on how long the account has been open",
    raffle_seniority_months: "Months per +1 ticket",
    raffle_seniority_max: "Max extra tickets",
    raffle_prizes_report: "Delivered prizes report",
    raffle_signature_title: "Signature for certificate",
    raffle_signature_name: "Name / position",
    raffle_signature_role: "Position",
    raffle_signature_image: "Signature image (PNG)",
    raffle_signature_upload: "Upload signature",
    raffle_share_slogan: "Social media caption",
    raffle_share_slogan_ph: "Congratulations to our weekly winner!",
    raffle_certificate: "Certificate",
    raffle_share_story: "Story",
    raffle_share_btn: "Share",
    raffle_share_title: "Weekly raffle winner",
    raffle_share_text: "🎉 Congratulations to {name}, winner of Grupo Estrella Hernández Inversiones's weekly raffle! Prize: {prize}. Thank you for being part of our cooperative family!",
    raffle_share_fallback: "Image downloaded and text copied. Attach it in your post.",
    security: "Security",
    twofa_prompt: "Enter the verification code we sent to",
    twofa_verify: "Verify",
    twofa_resend: "Resend code",
    twofa_resent: "Code resent",
    sec_title: "Security",
    sec_2fa: "Two-step verification (2FA)",
    sec_2fa_desc: "Require a code at login, in addition to your password.",
    sec_2fa_on: "On",
    sec_2fa_off: "Off",
    sec_channel_email: "Email",
    sec_channel_wa: "WhatsApp",
    sec_enable: "Enable 2FA",
    sec_disable: "Disable 2FA",
    sec_confirm: "Confirm",
    sec_verify_code: "Enter the code sent to",
    sec_code_sent: "Code sent",
    sec_enabled_ok: "Two-step verification enabled",
    sec_disabled_ok: "Two-step verification disabled",
    sec_logout_all: "Sign out of all devices",
    sec_logout_all_desc: "Instantly ends all active sessions.",
    sec_logout_all_done: "All sessions were closed",
    sec_admin_required: "Your account is administrative: two-step verification is required at every login.",
    sec_policy: "Require 2FA for all administrators",
    sec_policy_desc: "Each admin must set up their own 2FA first.",
    sec_policy_saved: "Policy updated",
    cred_title: "Account & login",
    cred_desc: "Change the email and password you use to sign in.",
    cred_current_pw: "Current password",
    cred_new_email: "New email",
    cred_new_pw: "New password (optional)",
    cred_save: "Save changes",
    cred_saved_ok: "Credentials updated",
    cred_current_pw_required: "Enter your current password",
    accrued_rate: "Yield",
    sv_rate: "Annual rate % (optional)",
    sv_rate_hint: "Leave empty to use the global rate",
    sv_lock_months: "Lock (months)",
    sv_penalty: "Early-withdrawal penalty %",
    lock_badge: "Locked",
    locked_until: "Locked until",
    lock_penalty_note: "Withdrawing or transferring before then applies a penalty of",
    savings_lock_notice_days: "Savings unlock reminder (days before)",
    ref_goal_title: "Monthly goal",
    ref_active_refs: "active",
    ref_goal_remaining_pre: "You need",
    ref_referrals_word: "referral(s)",
    ref_goal_next_lvl: "to reach the next level",
    ref_goal_disc: "discount",
    ref_goal_max: "Top level reached!",
    locks_title: "Accounts unlocking soon",
    days_left: "days",
    verify_loan: "Loan",
    verify_amount: "Amount",
    cert_officer_name: "Authorized officer (name)",
    cert_officer_title: "Officer title",
    filter_branch: "Branch",
    filter_month: "Month",
    all_branches: "All branches",
    all_months: "All months",
    unlock_alert_text: "savings account(s) unlock this month",
    verif_title: "Certificate verifications",
    verif_times: "times",
    verif_tab: "Verifications",
    raffle_export_pdf: "Download PDF",
    raffle_export_excel: "Download Excel",
    raffle_upload_photo: "Delivery photo/signature",
    raffle_view_photo: "View photo",
    raffle_delivery_photo: "Delivery proof",
    raffle_remove_photo: "Remove photo",
    saved: "Saved",
    calendar_tab: "Calendar",
    calendar_title: "Calendar",
    calendar_desc: "Organize your events and important dates",
    calendar_today: "Today",
    calendar_events_on: "Events on this day",
    calendar_no_events: "No events on this day",
    calendar_event: "Event",
    calendar_note: "Note",
    calendar_note_ph: "Optional note",
    calendar_add: "Add event",
    calendar_title_required: "The event title is required",
    calendar_auto_event: "Automatic",
    calendar_official: "Official",
    calendar_publish_all: "Publish for everyone",
    calendar_legend_personal: "Personal",
    calendar_legend_loan: "Loan installment",
    calendar_legend_term: "Deposit maturity",
    calendar_legend_official: "GEHI event",
    documents_tab: "Documents",
    documents_title: "Documents",
    documents_desc: "ID, passport and license photos of members",
    doc_search_ph: "Search by name, number or type...",
    doc_add: "Add document",
    doc_person: "Full name",
    doc_person_required: "The name is required",
    doc_type: "Document type",
    doc_type_id: "ID card",
    doc_type_passport: "Passport",
    doc_type_license: "License",
    doc_type_other: "Other",
    doc_number: "Number",
    doc_label: "Label",
    doc_note: "Note",
    doc_file: "File (image or PDF)",
    doc_file_hint: "Choose a file",
    doc_file_required: "A file is required",
    doc_view: "View",
    doc_no_results: "No documents",
    doc_confirm_delete: "Delete this document?",
    doc_client: "Link to member (optional)",
    doc_no_client: "No member",
    doc_linked_to: "Linked to",
    doc_export_pdf: "PDF",
    doc_export_excel: "Excel",
    doc_client_docs: "Documents",
    doc_expiry: "Expiry date (optional)",
    doc_expires: "Expires",
    doc_expired: "EXPIRED",
    doc_expiring_soon: "Expiring soon",
    doc_expiring_toggle: "Expiring/expired",
    my_documents_tab: "My documents",
    my_documents_empty: "You have no documents on file",
    ranking_tickets: "tickets",
    winners_banner_won: "won",
    jackpot_title: "Weekly Raffle Jackpot",
    jackpot_sub: "Save, get a term deposit or pay your loan to earn tickets. This week's draw is Sunday!",
    jackpot_play: "Join and play",
    jackpot_accumulated: "Accumulated for {weeks} week(s)",
    jackpot_draw_in: "Draw in",
    jackpot_today: "🎉 The draw is today!",
    jackpot_drawn_done: "✓ This week's draw is done — check the winners",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_min: "Min",
    cd_sec: "Sec",
    thermo_tickets: "tickets this week",
    thermo_participants: "members playing",
    thermo_hint: "The more members join, the bigger the community — don't miss Sunday's draw!",
    edit_permissions: "Edit Permissions",
    delete_employee: "Delete Employee",
    employee_created: "Employee created",
    permissions_updated: "Permissions updated",
    employee_deleted: "Employee deleted",
    confirm_delete: "Delete this employee?",
    super_admin: "Super Admin",
    no_permission_hint: "You don't have permission for this section.",
    save_permissions: "Save Permissions",
    perm_view_audit: "View audit log",
    // nav
    nav_accounts: "My Accounts",
    nav_activity: "Activity",
    nav_statement: "Statement",
    // audit
    audit_log: "Audit Log",
    audit_date: "Date",
    audit_actor: "User",
    audit_action: "Action",
    audit_detail: "Detail",
    no_audit: "No records yet.",
    act_deposit: "Deposit",
    act_withdrawal: "Withdrawal",
    act_rate_change: "Rate change",
    act_account_open: "Account opened",
    act_loan_create: "Loan created",
    act_loan_payment: "Loan payment",
    act_staff_create: "Employee created",
    act_staff_update: "Permissions updated",
    act_staff_delete: "Employee deleted",
    act_staff_suspend: "Employee suspended",
    act_staff_reactivate: "Employee reactivated",
    // loan payments
    remaining_balance: "Remaining balance",
    register_payment: "Register Payment",
    total_paid: "Total paid",
    paid_off: "Paid off",
    payment_receipt: "Payment receipt",
    send_due_notice: "Send payment reminder",
    my_loans: "My Loans",
    payment_amount: "Payment amount",
    loan_payment: "Loan payment",
    payment_done: "Payment registered",
    loan_paid_off: "Paid off",
    payments_made: "Payments",
    // statement
    statement: "Account Statement",
    statement_sub: "Download your statement in PDF with balances, earnings and movements.",
    download_statement: "Download PDF",
    generating: "Generating...",
    portfolio_tab: "Portfolio",
    portfolio_title: "Loan Portfolio Report",
    portfolio_sub: "Total lent, collected and pending by currency",
    portfolio_load_error: "Could not load the portfolio report",
    download_pdf: "Download PDF",
    total_lent: "Total lent",
    total_collected: "Collected",
    total_pending: "Pending balance",
    overdue: "Overdue",
    loans_lower: "loans",
    loans_count: "Loans",
    active_lower: "active",
    paid_off_lower: "paid off",
    // collections + transfers search
    collections_tab: "Collections",
    collections_title: "Collections Record",
    collections_sub: "All loan payments, savings deposits and term deposits received",
    collections_load_error: "Could not load the collections record",
    loan_payments_total: "Loan payments",
    savings_deposits_total: "Savings deposits",
    movements_lower: "movements",
    collected_today: "Collected today",
    collected_month: "Collected this month",
    last_7_days: "Last 7 days (approx. RD$)",
    term_deposit_label: "Term deposit",
    term_deposits_total: "Term deposits",
    kind_all: "All",
    kind_loans: "Loans",
    kind_savings: "Savings",
    kind_term: "Term",
    monthly_goal: "Monthly collection goal",
    goal_amount: "Goal amount",
    goal_saved: "Goal saved",
    goal_lower: "goal",
    goal_reached: "Goal reached!",
    of_goal: "of goal",
    goal_hint: "Set a monthly goal to track your collection progress.",
    // remittances
    remittances_tab: "Money Sends",
    remittances_title: "Money Sends",
    remittances_sub: "Send money for cash pickup at the destination branch",
    rm_new: "New send",
    rm_payment_method: "Payment method",
    rm_cash: "Cash",
    rm_from_savings: "From savings",
    rm_account: "Savings account",
    rm_select_account: "Select an account",
    rm_amount: "Amount to send",
    rm_fee: "Fee",
    rm_fee_lower: "fee",
    rm_total_charge: "Total charge",
    rm_recipient: "Recipient",
    rm_recipient_id: "ID card",
    rm_recipient_phone: "Phone",
    rm_province: "Province",
    rm_select_province: "Select province",
    rm_city: "City / town",
    rm_note: "Note",
    rm_confirm: "Confirm send",
    rm_sending: "Sending…",
    rm_created: "Send registered",
    rm_need_recipient: "Enter the recipient name",
    rm_need_province: "Select a province",
    rm_need_amount: "Enter a valid amount",
    rm_need_account: "Select a savings account",
    rm_no_savings: "You have no savings account. Choose Cash or ask staff to open one.",
    rm_fee_title: "Send fee",
    rm_fee_hint: "Fixed fee charged per send (same for everyone).",
    rm_fee_saved: "Fee saved",
    rm_search_ph: "Reference, sender, recipient, ID or phone",
    rm_all_provinces: "All provinces",
    rm_all_status: "All statuses",
    rm_empty: "No sends registered yet",
    rm_delivered: "Delivered",
    rm_not_received: "Not received",
    rm_mark_delivered: "Mark delivered",
    rm_mark_pending: "Mark not received",
    rm_notify_whatsapp: "Notify recipient via WhatsApp",
    rm_pending_title: "Pending sends by province",
    rm_pending_sub: "Undelivered money sends awaiting pickup",
    rm_client_search_ph: "Reference or recipient",
    rm_overdue: "overdue",
    rm_overdue_hint: "Pending sends older than the threshold",
    rm_overdue_days_label: "Overdue after (days)",
    rm_overdue_only: "Show overdue only",
    rm_overdue_only_on: "Showing overdue",
    rm_currency: "Currency to send",
    rm_free_send: "Free send",
    rm_free_hint: "no fee, deliver in RD$",
    rm_delivery_amount: "Amount to deliver",
    rm_need_delivery: "Enter the amount to deliver in RD$",
    rm_enabled_title: "Money sends",
    rm_enabled_on_hint: "Sends are active and available",
    rm_disabled_msg: "Sends temporarily unavailable",
    rm_enabled_on: "Sends activated",
    rm_enabled_off: "Sends deactivated",
    capital_col: "Principal",
    interest_col: "Interest",
    no_collections: "No collections in the selected period",
    loan_payment_label: "Loan payment",
    savings_deposit_label: "Savings deposit",
    from_date: "From",
    to_date: "To",
    all_currencies: "All currencies",
    error: "Error",
    search: "Search",
    all_transfers_title: "All Transfers",
    all_transfers_sub: "Search and audit member-to-member transfers",
    transfers_search_ph: "Reference, member or account #",
    from_account: "From",
    to_account: "To",
    // suspend
    suspend: "Suspend",
    reactivate: "Reactivate",
    suspended: "Suspended",
    active_label: "Active",
    // password reset
    forgot_password: "Forgot your password?",
    forgot_sub: "Enter your email and we'll send you a link to reset your password.",
    send_reset_link: "Send reset link",
    reset_password: "Reset password",
    new_password: "New password",
    confirm_password: "Confirm password",
    passwords_no_match: "Passwords do not match",
    invalid_link: "Invalid or expired link.",
    // receipt / due
    receipt: "Receipt",
    transfers_tab: "Transfers",
    no_transfers: "You have no transfers yet",
    reference: "Reference",
    counterpart: "Member",
    next_due: "Next due",
    due_notice: "Your next installment of {amount} is due on {date}.",
    // audit filters
    filter_actor: "User",
    filter_action: "Action",
    filter_from: "From",
    filter_to: "To",
    clear_filters: "Clear",
    all_actions: "All actions",
    act_term_deposit_create: "Term deposit created",
    act_term_deposit_delete: "Term deposit deleted",
    // term deposits
    term_deposits: "Term Deposits",
    new_term_deposit: "New Term Deposit",
    account_number: "Account #",
    holder: "Holder",
    send: "Send",
    reminder_day_label: "Reminder day:",
    reminder_day_saved: "Reminder day saved",
    reminder_day_invalid: "Enter a day between 1 and 31",
    overdue_loans_title: "Overdue loans",
    installments_behind: "Behind",
    first_name: "First name",
    last_name: "Last name",
    address: "Address",
    deposit_amount: "Deposit amount",
    start_date: "Start date",
    end_date: "End date",
    accrued_interest: "Accrued interest",
    projected_interest: "Interest at maturity",
    current_value: "Current value",
    maturity_value: "Value at maturity",
    maturity: "Maturity",
    matured: "Matured",
    active_term: "Active",
    days_elapsed: "Days",
    term_deposit_created: "Term deposit created",
    no_term_deposits: "No term deposits yet.",
    term_deposit_deleted: "Term deposit deleted",
    certificate: "Certificate",
    send_notice: "Notice",
    renew: "Renew",
    renew_deposit: "Renew Term Deposit",
    renew_months: "New term (months)",
    capitalize_interest: "Add earned interest to the new principal",
    renewed_ok: "Deposit renewed",
    notice_sent: "Notice sent",
    search_deposit: "Search by account # or holder...",
    act_term_deposit_notify: "Maturity notice sent",
    act_term_deposit_renew: "Term deposit renewed",
    act_term_deposit_update: "Term deposit edited",
    overview: "Overview",
    all_accounts_breakdown: "All Accounts Breakdown",
    regular_accounts: "Regular Accounts",
    edit: "Edit",
    edit_term_deposit: "Edit Term Deposit",
    my_term_deposits: "My Term Deposits",
    no_my_deposits: "You don't have term deposits yet.",
    td_notice: "When you deposit into Shares, the funds stay committed for a minimum of 6 months before you can withdraw them. If you need cash sooner, it's better to request a loan, which is processed in about 1 hour.",
    td_liquidate: "Early liquidation",
    td_liquidate_title: "Early liquidation",
    td_penalty_pct: "Penalty (% of principal)",
    td_forfeit_interest: "Interest forfeited",
    td_penalty_amount: "Penalty",
    td_net_payout: "Net to pay out",
    td_liquidated_ok: "Deposit liquidated",
    td_liquidate_reco: "Note: due to the penalty, it's usually better to request a loan (processed in ~1 hour) than to liquidate before maturity.",
    td_deposit_to_savings: "Deposit the net into the member's savings account",
    td_not_linked_cash: "Not linked to a member — the net will be paid out in cash (no savings deposit).",
    td_penalty_default: "Early-liquidation penalty (%)",
    td_penalty_default_hint: "Default penalty applied when liquidating Shares (term deposits) before maturity.",
    employees_tab: "Payroll",
    liquidations_tab: "Liquidations",
    new_employee: "New employee",
    edit_employee: "Edit employee",
    employee_name: "Full name",
    salary: "Salary paid",
    total_payroll: "Total payroll (active)",
    no_employees: "No employees yet.",
    employee_saved: "Employee saved",
    employee_deleted: "Employee deleted",
    confirm_delete: "Delete this record?",
    active: "Active",
    inactive: "Inactive",
    address: "Address",
    date: "Date",
    authorized_by: "Authorized by",
    no_liquidations: "No liquidations recorded yet.",
    upload_photo: "Upload photo",
    photo_updated: "Photo updated",
    pay_salary: "Pay salary",
    payroll_history: "Payroll history",
    period: "Period",
    amount: "Amount",
    register_payment: "Register",
    payment_registered: "Payment registered",
    no_payments: "No payments recorded yet.",
    per_year_short: "/yr",
    delete: "Delete",
    register_movement: "Register Movement",
    amount_label: "Amount",
    confirm: "Confirm",
    already_has: "Already opened",
    loading: "Loading...",
  },
  es: {
    brand: "Grupo Estrella Hernández Inversiones",
    tagline: "Tu respaldo financiero, tu crecimiento seguro",
    nav_home: "Inicio",
    nav_calculator: "Calculadora de Préstamos",
    nav_rates: "Nuestras Tasas",
    login: "Iniciar Sesión",
    register: "Únete Ahora",
    logout: "Cerrar Sesión",
    dashboard: "Mi Panel",
    admin_panel: "Administración",
    hero_title: "Haz crecer tu dinero con un aliado que crece contigo",
    hero_sub: "Cuentas de ahorro e inversión con ganancias reales al año, préstamos justos y un equipo que pone a sus clientes primero.",
    hero_cta: "Abrir una cuenta",
    hero_cta2: "Probar la calculadora",
    feat_savings_t: "Cuentas de Ahorro",
    feat_savings_d: "Genera intereses acumulados cada segundo, calculados sobre tu saldo real y el tiempo.",
    feat_shares_t: "Cuentas de Aportaciones",
    feat_shares_d: "Conviértete en socio y gana rendimientos anuales sobre tus aportaciones de participación.",
    feat_loans_t: "Préstamos Justos",
    feat_loans_d: "Amortización transparente con cuotas mensuales claras y sin cargos ocultos.",
    rates_title: "Tasas Anuales Vigentes",
    savings_rate: "Rendimiento Ahorro",
    shares_rate: "Rendimiento Aportaciones",
    per_year: "al año",
    calc_title: "Calculadora de Amortización de Préstamos",
    calc_sub: "Estima tu cuota mensual y el costo total al instante.",
    amount: "Monto del Préstamo",
    rate: "Tasa de Interés Anual (%)",
    term: "Plazo (meses)",
    calculate: "Calcular",
    monthly_payment: "Cuota Mensual",
    total_interest: "Interés Total",
    total_payment: "Total a Pagar",
    loans_tab: "Préstamos",
    loan_request_tab: "Solicitar Préstamo",
    activity_tab: "Actividades",
    loan_applications_tab: "Solicitudes de Préstamo",
    twofa_yes: "2FA activo",
    twofa_no: "Sin 2FA",
    loans_registry: "Registro de Préstamos",
    new_loan: "Nuevo Préstamo",
    edit_loan: "Editar Préstamo",
    loan_number: "N° Préstamo",
    loan_amount_label: "Monto del Préstamo",
    interest_rate: "Tasa de Interés",
    term_months: "Plazo (meses)",
    amortization: "Tabla de Amortización",
    months_unit: "meses",
    view_schedule: "Ver desglose",
    confirm_delete_loan: "¿Eliminar este préstamo?",
    schedule: "Tabla de Amortización",
    period: "#",
    payment: "Cuota",
    principal: "Capital",
    interest: "Interés",
    balance: "Saldo",
    welcome_back: "Bienvenido de nuevo",
    login_sub: "Ingresa con tu correo electrónico o número de teléfono",
    email_or_phone: "Correo o número de teléfono",
    password: "Contraseña",
    create_account: "Crea tu cuenta",
    register_sub: "Regístrate en un minuto",
    full_name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Número de teléfono",
    optional: "opcional",
    no_account: "¿No tienes una cuenta?",
    have_account: "¿Ya eres socio?",
    hello: "Hola",
    my_accounts: "Mis Cuentas",
    my_profile: "Mi Perfil",
    current_balance: "Saldo actual",
    accrued_earnings: "Ganancias acumuladas",
    annual_rate: "Tasa anual",
    no_accounts: "Aún no tienes cuentas. Contacta con la administración para abrir una.",
    recent_activity: "Actividad Reciente",
    no_activity: "Aún no hay movimientos.",
    type: "Tipo",
    date: "Fecha",
    savings: "Ahorro",
    shares: "Aportaciones",
    loan: "Préstamo",
    deposit: "Depósito",
    withdraw: "Retiro",
    transfer_in: "Transferencia recibida",
    transfer_out: "Transferencia enviada",
    raffle_refund: "Reembolso de boletos",
    raffle_purchase: "Compra de boletos",
    mv_amount: "Monto",
    invalid_amount: "Ingrese un monto válido",
    withdrawal: "Retiro",
    clients: "Clientes",
    manage_rates: "Gestionar Tasas",
    total_clients: "Total de Clientes",
    total_savings: "Total en Ahorros",
    total_shares: "Total en Aportaciones",
    active_loans: "Préstamos Activos",
    search_client: "Buscar cliente...",
    member_since: "Socio desde",
    add_account: "Agregar cuenta",
    account_type: "Tipo de cuenta",
    filter_all_members: "Todos",
    filter_no_savings: "Sin ahorro",
    filter_no_shares: "Sin aportaciones",
    filter_no_loan: "Sin préstamo",
    no_clients_found: "No se encontraron socios",
    sort_name: "Nombre (A–Z)",
    sort_recent: "Más recientes",
    sort_oldest: "Más antiguos",
    prev: "Anterior",
    next: "Siguiente",
    view: "Gestionar",
    open_account: "Abrir Cuenta",
    create_loan: "Crear Préstamo",
    save: "Guardar",
    cancel: "Cancelar",
    update_rates: "Actualizar Tasas",
    rates_updated: "Tasas actualizadas correctamente",
    exchange_rate: "Tasa de Cambio (RD$ por US$1)",
    exchange_hint: "Se usa para mostrar valores aproximados en la otra moneda.",
    approx: "aprox.",
    folio: "Folio",
    verify_deposit: "Verificar un Certificado",
    verify_sub: "Ingresa el folio o número de cuenta del certificado de acciones para verificar su autenticidad.",
    verify_placeholder: "Folio o número de cuenta",
    verify_btn: "Verificar",
    verify_valid: "Certificado válido",
    verify_download: "Descargar documento original",
    verify_invalid: "No se encontró ningún certificado con ese folio o número de cuenta.",
    verify_savings: "Cuenta de ahorro",
    verify_balance: "Saldo",
    nav_verify: "Verificar Certificado",
    total_dop: "Total en RD$",
    total_usd: "Total en US$",
    rate_history: "Historial de Cambios",
    no_history: "Aún no hay cambios registrados.",
    changed_by: "Modificado por",
    link_client: "Vincular a cliente",
    linked: "Vinculado",
    linked_by: "Vinculado por",
    select_client: "Selecciona un cliente",
    no_link: "Sin vínculo",
    download_overview: "Descargar resumen (PDF)",
    growth_title: "Crecimiento proyectado (12 meses)",
    growth_sub: "Valor estimado de tus ahorros, aportaciones y acciones durante el próximo año (en RD$).",
    projected_value: "Valor proyectado",
    maturity_notice_days: "Días de aviso antes del vencimiento",
    download_excel: "Descargar (Excel)",
    last_notice: "Último aviso",
    pending_only: "Solo pendientes",
    capital_tab: "Capital",
    capital_title: "Capital y Fondos",
    capital_load_error: "No se pudieron cargar los datos de capital",
    retry: "Reintentar",
    capital_contributed: "Capital aportado",
    growth: "Crecimiento",
    growth_amount: "Crecimiento",
    loans_out: "Préstamos otorgados",
    loans_collected: "Cobrado",
    savings_balance_total: "Ahorros captados",
    add_capital: "Ingresar Capital",
    deduct_capital: "Deducir Capital",
    capital_movement: "Movimiento de Capital",
    capital_added_ok: "Capital ingresado",
    capital_deducted_ok: "Capital deducido",
    client_photo: "Foto del Socio",
    national_id: "Cédula / ID",
    national_id_ph: "ej. 001-1234567-8",
    edit_profile: "Editar perfil",
    profile_updated: "Perfil actualizado",
    city: "Ciudad",
    date_of_birth: "Fecha de nacimiento",
    occupation: "Ocupación",
    internal_notes: "Notas internas",
    internal_notes_ph: "Notas privadas del admin (no visibles para el socio)",
    save_changes: "Guardar cambios",
    personal_info: "Datos personales",
    name_required: "El nombre es obligatorio",
    change_history: "Historial de cambios",
    no_changes_yet: "Aún no hay cambios registrados.",
    changed_field: "cambió",
    remove_photo: "Quitar foto",
    profile_photo: "Foto de perfil",
    birthdays_tab: "Cumpleaños",
    birthdays_of: "Cumpleaños de",
    no_birthdays: "Ningún socio cumple años este mes.",
    turns_years: "cumple",
    carousel_tab: "Carrusel y Avisos",
    manage_carousel: "Carrusel y avisos",
    carousel_hint: "Hasta 3 diapositivas. Los socios las verán en su cuenta.",
    slide: "Diapositiva",
    add_slide: "Agregar diapositiva",
    remove_slide: "Eliminar diapositiva",
    slide_image: "Imagen",
    slide_title: "Título",
    slide_text: "Texto",
    button_text: "Texto del botón",
    button_link: "Enlace del botón (opcional)",
    assign_person: "Asignar persona",
    assigned_person: "Persona asignada",
    remove_person: "Quitar persona",
    none_option: "— Ninguna —",
    announcements: "Avisos",
    add_announcement: "Agregar aviso",
    no_announcements: "No hay avisos.",
    news_for_you: "Novedades para ti",
    max_slides: "Máximo 3 diapositivas",
    btn_target: "Destino del botón",
    btn_target_url: "Enlace externo (URL)",
    btn_target_events: "Eventos Sociales (Calendario)",
    team_tab: "Nuestro Equipo",
    manage_team: "Nuestro Equipo / Directiva",
    team_hint: "Personas que verán los socios (foto, nombre y cargo).",
    add_member: "Agregar persona",
    member_role: "Cargo / rol",
    no_team: "Aún no hay miembros del equipo.",
    confirm_remove: "¿Eliminar este elemento?",
    confirm_remove_person: "¿Eliminar esta persona?",
    move_up: "Subir",
    move_down: "Bajar",
    event_capacity: "Cupo",
    spots_left: "cupos disponibles",
    event_full: "Lleno",
    attend: "Asistir",
    attending: "Asistirás",
    cancel_attend: "Cancelar asistencia",
    attendees: "asistentes",
    view_attendees: "Ver asistentes",
    no_attendees: "Sin asistentes aún.",
    demographics_tab: "Demografía",
    by_city: "Por ciudad",
    by_occupation: "Por ocupación",
    members_count: "socios",
    our_board: "Nuestra Directiva",
    our_board_sub: "Personas comprometidas con el crecimiento de GEHI.",
    active_members: "Socios más activos (eventos)",
    link_member: "Vincular a socio",
    link_member_hint: "Al vincular, la cuenta aparecerá en el perfil de ese socio.",
    member: "Socio",
    link_accounts: "Vincular cuentas",
    unlinked_accounts: "Cuentas sin vincular",
    no_unlinked: "No hay cuentas sin vincular.",
    link_here: "Vincular aquí",
    needs_review: "Revisar: sin coincidencia",
    suggested: "Sugerido",
    link_selected: "Vincular seleccionadas",
    link_matches: "Vincular coincidencias",
    link_history_title: "Historial de vinculación",
    whatsapp_settings: "WhatsApp / Twilio",
    whatsapp_hint: "Ingresa tus credenciales de Twilio para enviar avisos por WhatsApp a los socios. Se activará cuando actives el interruptor.",
    whatsapp_test: "Enviar prueba",
    whatsapp_test_ok: "Mensaje de prueba enviado",
    whatsapp_test_needs_save: "Primero activa y guarda WhatsApp",
    refresh: "Actualizar",
    notifications_tab: "Bitácora de envíos",
    notif_log_tab: "Bitácora de envíos",
    notifications_hint: "Registro de cada correo y WhatsApp que la plataforma ha enviado, con su estado de entrega.",
    notif_all_channels: "Todos los canales",
    notif_all_status: "Todos los estados",
    notif_email: "Correo",
    notif_sent: "Enviado",
    notif_failed: "Fallido",
    notif_skipped: "Omitido",
    notif_channel_col: "Canal",
    notif_to: "Destinatario",
    notif_subject: "Asunto / mensaje",
    notif_status_col: "Estado",
    notif_date: "Fecha",
    notif_resend: "Reenviar",
    notif_resent: "Mensaje reenviado",
    notif_records: "registros",
    notif_stats_title: "Entregas en los últimos 7 días",
    whatsapp_sandbox_title: "¿Usas el Sandbox de Twilio?",
    whatsapp_sandbox_hint: "Para probar gratis, usa como origen el número Sandbox whatsapp:+14155238886 y primero envía 'join <tu-código>' desde tu WhatsApp a ese número para activarlo. Luego coloca tu número abajo y presiona Enviar prueba.",
    enable_whatsapp: "Activar envíos por WhatsApp",
    twilio_sid: "Twilio Account SID",
    twilio_token: "Twilio Auth Token",
    whatsapp_from: "Número remitente de WhatsApp",
    admin_whatsapp: "WhatsApp del admin (opcional)",
    photo_saved: "Foto guardada",
    upload_photo: "Subir Foto",
    replace_photo: "Reemplazar Foto",
    documents: "Documentos",
    documents_hint: "Sube la cédula/ID y documentos de respaldo (imagen o PDF)",
    document_label: "Descripción",
    document_label_ph: "ej. Cédula, comprobante de ingresos...",
    document_uploaded: "Documento subido",
    no_documents: "Aún no hay documentos",
    view_document: "Ver documento",
    upload: "Subir",
    note: "Nota",
    by: "Por",
    manage_content_tab: "Contenido",
    perm_manage_content: "Editar contenido de la página principal",
    landing_content: "Contenido de la Página Principal",
    block_win: "Ventana",
    block_title: "Título",
    block_text: "Mensaje / Noticia",
    block_image: "Foto",
    upload_image: "Subir foto",
    uploading: "Subiendo…",
    save_content: "Guardar contenido",
    content_saved: "Contenido guardado",
    savings_goal: "Meta de ahorro (RD$)",
    set_goal: "Guardar meta",
    goal_saved: "Meta guardada",
    goal_line: "Meta",
    news_title: "Noticias y Anuncios",
    add_window: "Agregar ventana",
    remove_window: "Quitar",
    move_up: "Subir",
    move_down: "Bajar",
    visible: "Visible",
    button_text: "Texto del botón (opcional)",
    button_link: "Enlace del botón (opcional)",
    goal_progress: "Progreso de la meta",
    of_goal: "de tu meta",
    referral_tab: "Referidos",
    referral_title: "Programa de Referidos",
    referral_config: "Montos por Nivel",
    lvl2_amount: "Monto Nivel 2 (total)",
    lvl3_amount: "Monto Nivel 3 (total)",
    lvl4_amount: "Monto Nivel 4 (total)",
    per_person: "por persona",
    transfer: "Transferir",
    transfer_recipient: "Destinatario (N° de cuenta, correo o teléfono)",
    transfer_recipient_ph: "ej. AH-1234567890 o correo",
    transfer_need_recipient: "Ingresa el destinatario",
    transfer_recipient_not_found: "No se encontró una cuenta (misma moneda)",
    transfer_to: "Vas a transferir a",
    transfer_amount_label: "Monto",
    transfer_continue: "Continuar",
    transfer_confirm: "Confirmar transferencia",
    transfer_done: "Transferencia realizada",
    insufficient_funds: "Fondos insuficientes",
    ref_currency: "Moneda",
    ref_active: "Pagos activos",
    ref_tree: "Árbol de referidos",
    ref_report: "Ganancias por socio",
    place_client: "Colocar un cliente",
    select_sponsor: "Patrocinador (opcional)",
    ref_link: "Tu enlace de referido",
    copy: "Copiar",
    copied: "Copiado",
    my_network: "Mi red",
    referral_earnings: "Ganancias por referidos",
    bonus_pending: "Bono pendiente",
    bonus_pending_hint: "Calificado — se acreditará luego de 3 meses en la cuenta",
    bonus_waiting: "Por calificar",
    bonus_waiting_hint: "Se acredita cuando tu referido abra una cuenta con más de RD$1,000",
    bonus_payable_at: "Fecha de pago",
    bonus_status_paid: "Pagado",
    bonus_status_pending: "Pendiente",
    bonus_status_waiting: "Por calificar",
    status: "Estado",
    join_plan: "Unirme al plan de referidos",
    not_in_tree: "Aún no estás en el árbol de referidos.",
    active_tree: "Árbol activo",
    completed_tree: "Árbol completo",
    confirm_delete_savings: "¿Eliminar esta cuenta de ahorro?",
    empty_slot: "Vacío",
    member: "Socio",
    place: "Colocar",
    ref_saved: "Configuración de referidos guardada",
    invited_note: "Un socio te invitó — regístrate para unirte a su red.",
    invite_earn_title: "Invita y Gana",
    invite_earn_sub: "Trae a tus amigos y familiares a GEHI y gana recompensas reales por cada persona que se une a tu red.",
    invite_earn_upto: "Gana hasta",
    invite_earn_per: "por referido",
    invite_earn_p1: "Comparte tu enlace personal de invitación",
    invite_earn_p2: "Se registran y empiezan a ahorrar",
    invite_earn_p3: "Ganas bonos acreditados a tu cuenta",
    invite_earn_cta: "Empieza a ganar",
    calc_title: "Calculadora de referidos",
    calc_sub: "Mira cuánto podrías ganar invitando a tus amigos.",
    calc_friends: "Amigos que invitas",
    calc_you_earn: "Podrías ganar",
    calc_full: "¡Red completa en este ciclo!",
    calc_disclaimer: "Estimación según el plan de referidos vigente. Los bonos reales dependen de la actividad de tu red.",
    calc_share_wa: "Comparte por WhatsApp",
    calc_share_msg: "Estoy invitando amigos a Grupo Estrella Hernández Inversiones y ya voy por {n}. Únete con mi enlace y crezcamos juntos 💚",
    install_app: "Instalar app",
    onboarding_title: "¡Bienvenido a Grupo Estrella Hernández Inversiones!",
    onboarding_sub: "Aquí tienes algunos pasos rápidos para comenzar.",
    onboarding_step_accounts: "Revisa tus cuentas y saldos",
    onboarding_step_goal: "Fija tu meta de ahorro",
    onboarding_step_raffle: "Participa en el sorteo semanal",
    onboarding_step_referral: "Invita amigos y gana bonos",
    onboarding_skip: "Omitir por ahora",
    onboarding_done: "Entendido, ¡vamos!",
    testimonials_tab: "Testimonios",
    manage_testimonials: "Testimonios de socios",
    testimonials_hint: "Historias reales de socios que se muestran en la página pública.",
    add_testimonial: "Añadir testimonio",
    no_testimonials: "Aún no hay testimonios. Añade el primero.",
    testimonial_quote: "Testimonio",
    how_title: "Cómo funciona",
    how_sub: "Hacerte socio y hacer crecer tu dinero toma solo unos pasos.",
    how_s1_t: "Regístrate",
    how_s1_d: "Crea tu cuenta en minutos con tu cédula.",
    how_s2_t: "Abre tu ahorro",
    how_s2_d: "Empieza a ahorrar desde montos pequeños, a tu ritmo.",
    how_s3_t: "Haz crecer tu dinero",
    how_s3_d: "Gana intereses reales y accede a préstamos justos.",
    how_s4_t: "Participa y gana",
    how_s4_d: "Entra al sorteo semanal y al programa de referidos.",
    testimonials_title: "Lo que dicen nuestros clientes",
    testimonials_sub: "Historias reales de personas que crecen con GEHI.",
    rating_based_on: "según {n} opiniones de socios",
    faq_tab: "FAQ",
    notifications_tab: "Notificaciones",
    manage_faq: "Preguntas frecuentes",
    faq_hint: "Preguntas y respuestas que se muestran en la página pública.",
    add_faq: "Añadir pregunta",
    no_faq: "Aún no hay preguntas. Añade la primera.",
    faq_question: "Pregunta",
    faq_answer: "Respuesta",
    whatsapp_config_title: "WhatsApp de contacto",
    whatsapp_config_hint: "Número para el botón flotante de WhatsApp en la landing (con código de país).",
    whatsapp_number_label: "Número de WhatsApp",
    whatsapp_message_label: "Mensaje precargado (opcional)",
    faq_title: "Preguntas frecuentes",
    faq_sub: "Todo lo que necesitas saber antes de unirte.",
    whatsapp_float: "Escríbenos por WhatsApp",
    whatsapp_default_msg: "Hola, quiero información para hacerme socio de Grupo Estrella Hernández Inversiones.",
    member_testimonial_title: "Comparte tu experiencia",
    member_testimonial_sub: "Cuéntanos tu historia. Una vez aprobada, podría aparecer en nuestra página pública.",
    your_testimonial: "Tu testimonio",
    testimonial_role_optional: "Título (opcional)",
    testimonial_placeholder: "¿Qué es lo que más valoras de GEHI?",
    submit_testimonial: "Enviar testimonio",
    testimonial_thanks: "¡Gracias! Tu testimonio quedó pendiente de aprobación.",
    testimonial_min: "Escribe al menos 10 caracteres.",
    testimonial_pending: "Pendiente de aprobación",
    testimonial_published: "Publicado",
    approve_testimonial: "Aprobar",
    status_pending: "pendiente",
    status_approved: "Aprobado",
    member_badge: "Socio",
    visible: "Visible",
    hidden: "Oculto",
    referral_code_label: "Enlace o código de referido",
    referral_code_ph: "Pega el enlace o el código (ej. ABC123)",
    referral_detected: "Código de referido detectado",
    referral_checking: "Verificando código…",
    referred_by: "Referido por",
    referral_invalid: "Código de referido no encontrado",
    referral: "Referido",
    level: "Nivel",
    savings_tab: "Cuentas de Ahorro",
    savings_accounts: "Cuentas de Ahorro",
    new_savings: "Nueva cuenta de ahorro",
    save: "Guardar",
    account_opened: "Cuenta abierta",
    tx_done: "Movimiento registrado",
    loan_created: "Préstamo creado",
    principal_amount: "Monto del capital",
    monthly: "Mensual",
    accounts: "Cuentas",
    actions: "Acciones",
    client: "Cliente",
    manage_client: "Gestionar cliente",
    currency: "Moneda",
    usd: "Dólares (USD)",
    dop: "Pesos dominicanos (RD$)",
    staff: "Personal",
    manage_staff_tab: "Empleados y Roles",
    new_employee: "Nuevo Empleado",
    employees: "Empleados",
    role: "Rol",
    permissions: "Permisos",
    role_template: "Rol predefinido",
    custom: "Permisos personalizados",
    none_template: "Ninguno (solo personalizados)",
    tmpl_cajero: "Cajero (depósitos/retiros)",
    tmpl_oficial_credito: "Oficial de Crédito (préstamos)",
    tmpl_gerente: "Gerente (todas las operaciones)",
    perm_view_clients: "Ver clientes y saldos",
    perm_manage_accounts: "Abrir cuentas de ahorro/aportaciones",
    perm_manage_transactions: "Registrar depósitos y retiros",
    perm_manage_loans: "Crear préstamos",
    perm_manage_rates: "Cambiar tasas (%)",
    perm_manage_staff: "Gestionar empleados y permisos",
    create_employee: "Crear Empleado",
    branch_name: "Sucursal",
    branch_optional: "Sucursal (opcional)",
    collected_by_branch: "Por sucursal (hoy)",
    ranking_tab: "Ranking Sucursales",
    branch_ranking_title: "Ranking de Sucursales del Mes",
    branch_ranking_desc: "Total cobrado por sucursal (préstamos + ahorros + acciones), convertido a RD$.",
    ranking_month: "Mes",
    ranking_total_collected: "Total cobrado este mes",
    ranking_movements: "movimientos",
    ranking_empty: "Aún no hay cobros registrados para este mes.",
    my_position_title: "Tu posición del mes",
    pos_you_are: "Vas",
    pos_of: "de",
    pos_collected: "cobrado este mes",
    pos_gap_pre: "Te faltan",
    pos_gap_post: "para alcanzar a",
    pos_leader: "¡Vas de líder este mes!",
    raffle_tab: "Sorteos",
    raffle_title: "Sorteo Semanal",
    raffle_desc: "Cada depósito o pago le da al socio un boleto estilo Powerball. El sorteo sale cada domingo.",
    raffle_settings: "Configuración",
    raffle_enable: "Activar sorteo",
    raffle_prize: "Premio",
    raffle_auto_draw: "Sorteo automático",
    raffle_auto_hint: "Si está activo, el ganador se sortea automáticamente en la fecha y hora programadas abajo",
    raffle_draw_datetime: "Fecha y hora del sorteo",
    raffle_draw_datetime_hint: "Elige la fecha y hora exactas (RD/AST). Se ejecuta automáticamente y se reprograma a la semana siguiente. El sorteo corre al inicio de la hora a partir de ese momento.",
    raffle_this_week: "Esta semana",
    raffle_tickets_count: "boletos generados",
    raffle_draw_now: "Sortear ahora",
    raffle_confirm_draw: "¿Sortear el ganador de esta semana ahora?",
    raffle_winner: "Ganador",
    raffle_winning_numbers: "Números ganadores",
    raffle_past_draws: "Sorteos anteriores",
    raffle_my_tickets: "Mis boletos de la semana",
    raffle_week: "Semana",
    raffle_no_tickets: "Aún no tienes boletos. ¡Haz un depósito o pago para obtener uno!",
    raffle_you_won: "¡Ganaste el sorteo semanal!",
    raffle_last_winner: "Último ganador",
    raffle_off: "El sorteo no está activo por el momento.",
    raffle_per_amount: "Boletos por monto (0 = 1 por transacción)",
    raffle_per_amount_hint: "ej. 1000 da 1 boleto por cada RD$1,000 depositado (máx 50)",
    raffle_download: "Descargar boleto",
    raffle_notify_whatsapp: "Avisar por WhatsApp",
    raffle_multipliers: "Boletos por producto (multiplicador)",
    raffle_multipliers_hint: "Multiplica los boletos según el producto (ej. 2 = doble)",
    raffle_mult_savings: "Ahorro",
    raffle_mult_term: "Acciones",
    raffle_mult_loan: "Préstamo",
    raffle_sources: "Áreas activas (generan boletos)",
    raffle_sources_hint: "Apaga un área para que los depósitos/pagos de esa área dejen de generar boletos (anti-trampa)",
    raffle_paid_enable: "Cobrar por boletos",
    raffle_paid_hint: "Permite a los socios comprar boletos adicionales, descontando de su saldo de ahorro.",
    raffle_ticket_price: "Precio por boleto",
    raffle_paid_max: "Máx. boletos por compra",
    raffle_buy_title: "Comprar boletos",
    raffle_buy_hint: "Precio por boleto",
    raffle_buy_max: "Máximo por compra",
    raffle_buy_qty: "Cantidad",
    raffle_buy_account: "Pagar desde",
    raffle_buy_total: "Total",
    raffle_buy_btn: "Comprar",
    raffle_buy_no_account: "No tienes una cuenta de ahorro en la moneda del boleto.",
    raffle_bought: "Compraste",
    raffle_pick_account: "Selecciona una cuenta",
    raffle_paid: "Comprado",
    raffle_receipt_ready: "Recibo listo",
    raffle_download_receipt: "Descargar recibo",
    raffle_weekly_max: "Máx. por semana (0 = sin límite)",
    raffle_weekly_left: "disponibles esta semana",
    raffle_my_purchases: "Mis compras",
    raffle_admin_purchases: "Compras de boletos",
    raffle_refund_btn: "Reembolsar",
    raffle_refunded: "Reembolsado",
    raffle_confirm_refund: "¿Reembolsar esta compra y devolver el saldo al socio?",
    raffle_revenue_title: "Ingresos por venta de boletos",
    raffle_revenue_total: "Total recaudado",
    raffle_revenue_by_week: "Por semana",
    raffle_revenue_by_branch: "Por sucursal",
    raffle_src_savings: "Cuentas de ahorro",
    raffle_src_term: "Acciones",
    raffle_src_loan: "Pagos de préstamo",
    raffle_countdown_pre: "Faltan",
    raffle_countdown_post: "para el sorteo del domingo",
    raffle_today: "¡El sorteo es hoy! Mucha suerte 🍀",
    raffle_drawn_done: "Sorteo realizado ✓ — mira el ganador abajo",
    raffle_exact_prize: "Premio exacto (sin acumulado)",
    raffle_exact_hint: "Si está activo, el premio es siempre el monto que escribes; no se acumula nada.",
    raffle_exact_active: "Premio exacto",
    raffle_day: "día",
    raffle_days: "días",
    winners_title: "Ganadores del Sorteo Semanal",
    winners_sub: "Cada depósito o pago acumula boletos. ¡Estos son nuestros ganadores afortunados recientes!",
    winners_week: "Semana",
    raffle_download_all: "Descargar todos",
    raffle_participation: "Participación por sucursal",
    raffle_participation_tickets: "boletos",
    raffle_mark_claimed: "Marcar entregado",
    raffle_claimed: "Entregado",
    raffle_no_winner: "Sin ganador (acumulado)",
    raffle_no_winner_toast: "Nadie coincidió esta semana — el premio se acumula",
    raffle_rollover: "Premio acumulado",
    raffle_pot: "Premio de esta semana",
    raffle_rollover_weeks: "acumulándose por semanas",
    raffle_secondary_prizes: "Premios menores (aciertos parciales)",
    raffle_secondary_hint: "2º premio: 4 blancos + roja · 3er premio: 3 blancos + roja (0 = desactivado)",
    raffle_prize4: "2º premio (4 blancos + roja)",
    raffle_prize3: "3er premio (3 blancos + roja)",
    raffle_minor_winners: "Ganadores menores",
    raffle_seniority: "Boletos por antigüedad",
    raffle_seniority_hint: "Boletos extra según el tiempo que lleva abierta la cuenta",
    raffle_seniority_months: "Meses por cada +1 boleto",
    raffle_seniority_max: "Máx. boletos extra",
    raffle_prizes_report: "Reporte de premios entregados",
    raffle_signature_title: "Firma para el certificado",
    raffle_signature_name: "Nombre / cargo",
    raffle_signature_role: "Cargo",
    raffle_signature_image: "Imagen de firma (PNG)",
    raffle_signature_upload: "Subir firma",
    raffle_share_slogan: "Texto para redes sociales",
    raffle_share_slogan_ph: "¡Felicidades a nuestro ganador de la semana!",
    raffle_certificate: "Certificado",
    raffle_share_story: "Historia",
    raffle_share_btn: "Compartir",
    raffle_share_title: "Ganador del sorteo semanal",
    raffle_share_text: "🎉 ¡Felicidades a {name}, ganador(a) del sorteo semanal de Grupo Estrella Hernández Inversiones! Premio: {prize}. ¡Gracias por ser parte de nuestra familia cooperativa!",
    raffle_share_fallback: "Imagen descargada y texto copiado. Adjúntala en tu publicación.",
    security: "Seguridad",
    twofa_prompt: "Ingresa el código de verificación que enviamos a",
    twofa_verify: "Verificar",
    twofa_resend: "Reenviar código",
    twofa_resent: "Código reenviado",
    sec_title: "Seguridad",
    sec_2fa: "Verificación en dos pasos (2FA)",
    sec_2fa_desc: "Pide un código al iniciar sesión, además de tu contraseña.",
    sec_2fa_on: "Activo",
    sec_2fa_off: "Inactivo",
    sec_channel_email: "Correo",
    sec_channel_wa: "WhatsApp",
    sec_enable: "Activar 2FA",
    sec_disable: "Desactivar 2FA",
    sec_confirm: "Confirmar",
    sec_verify_code: "Ingresa el código enviado a",
    sec_code_sent: "Código enviado",
    sec_enabled_ok: "Verificación en dos pasos activada",
    sec_disabled_ok: "Verificación en dos pasos desactivada",
    sec_logout_all: "Cerrar sesión en todos los dispositivos",
    sec_logout_all_desc: "Cierra todas las sesiones activas al instante.",
    sec_logout_all_done: "Se cerraron todas las sesiones",
    sec_admin_required: "Tu cuenta es administrativa: la verificación en dos pasos es obligatoria en cada inicio de sesión.",
    sec_policy: "Exigir 2FA a todos los administradores",
    sec_policy_desc: "Cada administrador debe activar primero su propio 2FA.",
    sec_policy_saved: "Política actualizada",
    cred_title: "Cuenta e inicio de sesión",
    cred_desc: "Cambia el correo y la contraseña con los que inicias sesión.",
    cred_current_pw: "Contraseña actual",
    cred_new_email: "Nuevo correo",
    cred_new_pw: "Nueva contraseña (opcional)",
    cred_save: "Guardar cambios",
    cred_saved_ok: "Credenciales actualizadas",
    cred_current_pw_required: "Ingresa tu contraseña actual",
    accrued_rate: "Rendimiento",
    sv_rate: "Tasa anual % (opcional)",
    sv_rate_hint: "Vacío = usa la tasa global",
    sv_lock_months: "Bloqueo (meses)",
    sv_penalty: "Penalización por retiro anticipado %",
    lock_badge: "Bloqueado",
    locked_until: "Bloqueado hasta",
    lock_penalty_note: "Retirar o transferir antes aplica una penalización de",
    savings_lock_notice_days: "Aviso de desbloqueo de ahorro (días antes)",
    ref_goal_title: "Meta del mes",
    ref_active_refs: "activos",
    ref_goal_remaining_pre: "Te faltan",
    ref_referrals_word: "referido(s)",
    ref_goal_next_lvl: "para el siguiente nivel",
    ref_goal_disc: "de descuento",
    ref_goal_max: "¡Nivel máximo alcanzado!",
    locks_title: "Cuentas por desbloquear pronto",
    days_left: "días",
    verify_loan: "Préstamo",
    verify_amount: "Monto",
    cert_officer_name: "Oficial autorizado (nombre)",
    cert_officer_title: "Cargo del oficial",
    filter_branch: "Sucursal",
    filter_month: "Mes",
    all_branches: "Todas las sucursales",
    all_months: "Todos los meses",
    unlock_alert_text: "cuenta(s) de ahorro se desbloquean este mes",
    verif_title: "Verificaciones de certificados",
    verif_times: "veces",
    verif_tab: "Verificaciones",
    raffle_export_pdf: "Descargar PDF",
    raffle_export_excel: "Descargar Excel",
    raffle_upload_photo: "Foto/firma de entrega",
    raffle_view_photo: "Ver foto",
    raffle_delivery_photo: "Comprobante de entrega",
    raffle_remove_photo: "Quitar foto",
    saved: "Guardado",
    calendar_tab: "Calendario",
    calendar_title: "Calendario",
    calendar_desc: "Organiza tus eventos y fechas importantes",
    calendar_today: "Hoy",
    calendar_events_on: "Eventos de este día",
    calendar_no_events: "No hay eventos este día",
    calendar_event: "Evento",
    calendar_note: "Nota",
    calendar_note_ph: "Nota opcional",
    calendar_add: "Agregar evento",
    calendar_title_required: "El título del evento es obligatorio",
    calendar_auto_event: "Automático",
    calendar_official: "Oficial",
    calendar_publish_all: "Publicar para todos",
    calendar_legend_personal: "Personal",
    calendar_legend_loan: "Cuota de préstamo",
    calendar_legend_term: "Vencimiento de acciones",
    calendar_legend_official: "Evento de GEHI",
    documents_tab: "Documentos",
    documents_title: "Documentos",
    documents_desc: "Fotos de cédula, pasaporte y licencia de los socios",
    doc_search_ph: "Buscar por nombre, número o tipo...",
    doc_add: "Agregar documento",
    doc_person: "Nombre completo",
    doc_person_required: "El nombre es obligatorio",
    doc_type: "Tipo de documento",
    doc_type_id: "Cédula",
    doc_type_passport: "Pasaporte",
    doc_type_license: "Licencia",
    doc_type_other: "Otro",
    doc_number: "Número",
    doc_label: "Etiqueta",
    doc_note: "Nota",
    doc_file: "Archivo (imagen o PDF)",
    doc_file_hint: "Elige un archivo",
    doc_file_required: "Debes adjuntar un archivo",
    doc_view: "Ver",
    doc_no_results: "No hay documentos",
    doc_confirm_delete: "¿Eliminar este documento?",
    doc_client: "Vincular al socio (opcional)",
    doc_no_client: "Sin socio",
    doc_linked_to: "Vinculado a",
    doc_export_pdf: "PDF",
    doc_export_excel: "Excel",
    doc_client_docs: "Documentos",
    doc_expiry: "Fecha de vencimiento (opcional)",
    doc_expires: "Vence",
    doc_expired: "VENCIDO",
    doc_expiring_soon: "Por vencer",
    doc_expiring_toggle: "Por vencer/vencidos",
    my_documents_tab: "Mis documentos",
    my_documents_empty: "No tienes documentos registrados",
    ranking_tickets: "boletos",
    winners_banner_won: "ganó",
    jackpot_title: "Bote del Sorteo Semanal",
    jackpot_sub: "Ahorra, abre una cuenta de acciones o paga tu préstamo para ganar boletos. ¡El sorteo es el domingo!",
    jackpot_play: "Únete y participa",
    jackpot_accumulated: "Acumulado por {weeks} semana(s)",
    jackpot_draw_in: "Sorteo en",
    jackpot_today: "🎉 ¡El sorteo es hoy!",
    jackpot_drawn_done: "✓ El sorteo de esta semana ya se realizó — mira los ganadores",
    cd_days: "Días",
    cd_hours: "Horas",
    cd_min: "Min",
    cd_sec: "Seg",
    thermo_tickets: "boletos esta semana",
    thermo_participants: "socios participando",
    thermo_hint: "Mientras más socios se unen, más grande es la comunidad. ¡No te pierdas el sorteo del domingo!",
    edit_permissions: "Editar Permisos",
    delete_employee: "Eliminar Empleado",
    employee_created: "Empleado creado",
    permissions_updated: "Permisos actualizados",
    employee_deleted: "Empleado eliminado",
    confirm_delete: "¿Eliminar este empleado?",
    super_admin: "Super Administrador",
    no_permission_hint: "No tienes permiso para esta sección.",
    save_permissions: "Guardar Permisos",
    perm_view_audit: "Ver registro de auditoría",
    // nav
    nav_accounts: "Mis Cuentas",
    nav_activity: "Movimientos",
    nav_statement: "Estado de Cuenta",
    // audit
    audit_log: "Registro de Auditoría",
    audit_date: "Fecha",
    audit_actor: "Usuario",
    audit_action: "Acción",
    audit_detail: "Detalle",
    no_audit: "Aún no hay registros.",
    act_deposit: "Depósito",
    act_withdrawal: "Retiro",
    act_rate_change: "Cambio de tasa",
    act_account_open: "Cuenta abierta",
    act_loan_create: "Préstamo creado",
    act_loan_payment: "Pago de préstamo",
    act_staff_create: "Empleado creado",
    act_staff_update: "Permisos actualizados",
    act_staff_delete: "Empleado eliminado",
    act_staff_suspend: "Empleado suspendido",
    act_staff_reactivate: "Empleado reactivado",
    // loan payments
    remaining_balance: "Saldo pendiente",
    register_payment: "Registrar Pago",
    total_paid: "Total abonado",
    paid_off: "Saldado",
    payment_receipt: "Recibo de pago",
    send_due_notice: "Enviar aviso de cuota",
    my_loans: "Mis Préstamos",
    payment_amount: "Monto del pago",
    loan_payment: "Pago de préstamo",
    payment_done: "Pago registrado",
    loan_paid_off: "Saldado",
    payments_made: "Pagos",
    // statement
    statement: "Estado de Cuenta",
    statement_sub: "Descarga tu estado de cuenta en PDF con saldos, ganancias y movimientos.",
    download_statement: "Descargar PDF",
    generating: "Generando...",
    portfolio_tab: "Cartera",
    portfolio_title: "Reporte de Cartera de Préstamos",
    portfolio_sub: "Total prestado, cobrado y pendiente por moneda",
    portfolio_load_error: "No se pudo cargar el reporte de cartera",
    download_pdf: "Descargar PDF",
    total_lent: "Total prestado",
    total_collected: "Cobrado",
    total_pending: "Saldo por cobrar",
    overdue: "En mora",
    loans_lower: "préstamos",
    loans_count: "Préstamos",
    active_lower: "activos",
    paid_off_lower: "saldados",
    // collections + transfers search
    collections_tab: "Cobros",
    collections_title: "Registro de Cobros",
    collections_sub: "Todos los abonos de préstamos, depósitos de ahorro y acciones recibidos",
    collections_load_error: "No se pudo cargar el registro de cobros",
    loan_payments_total: "Abonos de préstamos",
    savings_deposits_total: "Depósitos de ahorro",
    movements_lower: "movimientos",
    collected_today: "Cobrado hoy",
    collected_month: "Cobrado este mes",
    last_7_days: "Últimos 7 días (aprox. RD$)",
    term_deposit_label: "Acciones",
    term_deposits_total: "Acciones",
    kind_all: "Todo",
    kind_loans: "Préstamos",
    kind_savings: "Ahorro",
    kind_term: "Acciones",
    monthly_goal: "Meta mensual de cobros",
    goal_amount: "Monto meta",
    goal_saved: "Meta guardada",
    goal_lower: "meta",
    goal_reached: "¡Meta alcanzada!",
    of_goal: "de la meta",
    goal_hint: "Fija una meta mensual para seguir el avance de tus cobros.",
    // remittances
    remittances_tab: "Envíos",
    remittances_title: "Envíos de Dinero",
    remittances_sub: "Envía dinero para retiro en efectivo en la sucursal de destino",
    rm_new: "Nuevo envío",
    rm_payment_method: "Forma de pago",
    rm_cash: "Efectivo",
    rm_from_savings: "Desde ahorros",
    rm_account: "Cuenta de ahorro",
    rm_select_account: "Selecciona una cuenta",
    rm_amount: "Monto a enviar",
    rm_fee: "Tarifa",
    rm_fee_lower: "tarifa",
    rm_total_charge: "Total a cobrar",
    rm_recipient: "Destinatario",
    rm_recipient_id: "Cédula",
    rm_recipient_phone: "Teléfono",
    rm_province: "Provincia",
    rm_select_province: "Selecciona provincia",
    rm_city: "Ciudad / municipio",
    rm_note: "Nota",
    rm_confirm: "Confirmar envío",
    rm_sending: "Enviando…",
    rm_created: "Envío registrado",
    rm_need_recipient: "Ingresa el nombre del destinatario",
    rm_need_province: "Selecciona una provincia",
    rm_need_amount: "Ingresa un monto válido",
    rm_need_account: "Selecciona una cuenta de ahorro",
    rm_no_savings: "No tienes cuenta de ahorro. Elige Efectivo o pide al personal que te abra una.",
    rm_fee_title: "Tarifa de envío",
    rm_fee_hint: "Tarifa fija cobrada por cada envío (igual para todos).",
    rm_fee_saved: "Tarifa guardada",
    rm_search_ph: "Referencia, remitente, destinatario, cédula o teléfono",
    rm_all_provinces: "Todas las provincias",
    rm_all_status: "Todos los estados",
    rm_empty: "Aún no hay envíos registrados",
    rm_delivered: "Entregado",
    rm_not_received: "No recibido",
    rm_mark_delivered: "Marcar entregado",
    rm_mark_pending: "Marcar no recibido",
    rm_notify_whatsapp: "Avisar al destinatario por WhatsApp",
    rm_pending_title: "Envíos pendientes por provincia",
    rm_pending_sub: "Envíos de dinero sin entregar, esperando retiro",
    rm_client_search_ph: "Referencia o destinatario",
    rm_overdue: "atrasados",
    rm_overdue_hint: "Envíos pendientes con más días que el umbral",
    rm_overdue_days_label: "Atrasado tras (días)",
    rm_overdue_only: "Ver solo atrasados",
    rm_overdue_only_on: "Mostrando atrasados",
    rm_currency: "Moneda a enviar",
    rm_free_send: "Envío gratis",
    rm_free_hint: "sin tarifa, entrega en RD$",
    rm_delivery_amount: "Monto a entregar",
    rm_need_delivery: "Ingresa el monto a entregar en RD$",
    rm_enabled_title: "Envíos de dinero",
    rm_enabled_on_hint: "Los envíos están activos y disponibles",
    rm_disabled_msg: "Envíos temporalmente no disponibles",
    rm_enabled_on: "Envíos activados",
    rm_enabled_off: "Envíos desactivados",
    capital_col: "Capital",
    interest_col: "Interés",
    no_collections: "No hay cobros en el período seleccionado",
    loan_payment_label: "Abono préstamo",
    savings_deposit_label: "Depósito ahorro",
    from_date: "Desde",
    to_date: "Hasta",
    all_currencies: "Todas las monedas",
    error: "Error",
    search: "Buscar",
    all_transfers_title: "Todas las Transferencias",
    all_transfers_sub: "Busca y audita las transferencias entre socios",
    transfers_search_ph: "Referencia, socio o N° de cuenta",
    from_account: "De",
    to_account: "Para",
    // suspend
    suspend: "Suspender",
    reactivate: "Reactivar",
    suspended: "Suspendido",
    active_label: "Activo",
    // password reset
    forgot_password: "¿Olvidaste tu contraseña?",
    forgot_sub: "Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.",
    send_reset_link: "Enviar enlace",
    reset_password: "Restablecer contraseña",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar contraseña",
    passwords_no_match: "Las contraseñas no coinciden",
    invalid_link: "Enlace inválido o expirado.",
    // receipt / due
    receipt: "Recibo",
    transfers_tab: "Transferencias",
    no_transfers: "Aún no tienes transferencias",
    reference: "Referencia",
    counterpart: "Socio",
    next_due: "Próxima cuota",
    due_notice: "Tu próxima cuota de {amount} vence el {date}.",
    // audit filters
    filter_actor: "Usuario",
    filter_action: "Acción",
    filter_from: "Desde",
    filter_to: "Hasta",
    clear_filters: "Limpiar",
    all_actions: "Todas las acciones",
    act_term_deposit_create: "Acción creada",
    act_term_deposit_delete: "Acción eliminada",
    // term deposits
    term_deposits: "Acciones",
    new_term_deposit: "Nueva Acción",
    account_number: "N° de Cuenta",
    holder: "Titular",
    send: "Enviar",
    reminder_day_label: "Día del recordatorio:",
    reminder_day_saved: "Día del recordatorio guardado",
    reminder_day_invalid: "Ingresa un día entre 1 y 31",
    overdue_loans_title: "Préstamos en mora",
    installments_behind: "Atrasadas",
    first_name: "Nombre",
    last_name: "Apellido",
    address: "Dirección",
    deposit_amount: "Monto a depositar",
    start_date: "Fecha inicial",
    end_date: "Fecha final",
    accrued_interest: "Interés acumulado",
    projected_interest: "Interés al vencimiento",
    current_value: "Valor actual",
    maturity_value: "Valor al vencimiento",
    maturity: "Vencimiento",
    matured: "Vencido",
    active_term: "Activo",
    days_elapsed: "Días",
    term_deposit_created: "Acción creada",
    no_term_deposits: "Aún no hay acciones.",
    term_deposit_deleted: "Acción eliminada",
    certificate: "Certificado",
    send_notice: "Aviso",
    renew: "Renovar",
    renew_deposit: "Renovar Acción",
    renew_months: "Nuevo plazo (meses)",
    capitalize_interest: "Sumar el interés ganado al nuevo capital",
    renewed_ok: "Acción renovada",
    notice_sent: "Aviso enviado",
    search_deposit: "Buscar por N° de cuenta o titular...",
    act_term_deposit_notify: "Aviso de vencimiento enviado",
    act_term_deposit_renew: "Acción renovada",
    act_term_deposit_update: "Acción editada",
    overview: "Resumen",
    all_accounts_breakdown: "Desglose de Todas las Cuentas",
    regular_accounts: "Cuentas Regulares",
    edit: "Editar",
    edit_term_deposit: "Editar Acción",
    my_term_deposits: "Mis Acciones",
    no_my_deposits: "Aún no tienes acciones.",
    td_notice: "Al depositar en Acciones, el dinero queda comprometido por un mínimo de 6 meses antes de poder retirarlo. Si el socio necesita efectivo antes, es preferible solicitar un préstamo, que se procesa en aproximadamente 1 hora.",
    td_liquidate: "Liquidar anticipado",
    td_liquidate_title: "Liquidación anticipada",
    td_penalty_pct: "Penalidad (% del capital)",
    td_forfeit_interest: "Interés que se pierde",
    td_penalty_amount: "Penalidad",
    td_net_payout: "Neto a entregar",
    td_liquidated_ok: "Depósito liquidado",
    td_liquidate_reco: "Nota: por la penalidad, suele convenir más solicitar un préstamo (se procesa en ~1 hora) que liquidar antes de tiempo.",
    td_deposit_to_savings: "Depositar el neto en la cuenta de ahorro del socio",
    td_not_linked_cash: "No está vinculado a un socio — el neto se entrega en efectivo (sin depósito a ahorro).",
    td_penalty_default: "Penalidad por retiro anticipado (%)",
    td_penalty_default_hint: "Penalidad por defecto al liquidar Acciones (plazo fijo) antes del vencimiento.",
    employees_tab: "Nómina",
    liquidations_tab: "Liquidaciones",
    new_employee: "Nuevo empleado",
    edit_employee: "Editar empleado",
    employee_name: "Nombre completo",
    salary: "Sueldo que se paga",
    total_payroll: "Nómina total (activos)",
    no_employees: "Aún no hay empleados.",
    employee_saved: "Empleado guardado",
    employee_deleted: "Empleado eliminado",
    confirm_delete: "¿Eliminar este registro?",
    active: "Activo",
    inactive: "Inactivo",
    address: "Dirección",
    date: "Fecha",
    authorized_by: "Autorizó",
    no_liquidations: "Aún no hay liquidaciones registradas.",
    upload_photo: "Subir foto",
    photo_updated: "Foto actualizada",
    pay_salary: "Pagar sueldo",
    payroll_history: "Historial de pagos",
    period: "Período",
    amount: "Monto",
    register_payment: "Registrar",
    payment_registered: "Pago registrado",
    no_payments: "Aún no hay pagos registrados.",
    per_year_short: "/año",
    delete: "Eliminar",
    register_movement: "Registrar Movimiento",
    amount_label: "Monto",
    confirm: "Confirmar",
    already_has: "Ya abierta",
    loading: "Cargando...",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("coop_lang") || "es");
  const toggle = () => {
    const next = lang === "es" ? "en" : "es";
    setLang(next);
    localStorage.setItem("coop_lang", next);
  };
  const t = useMemo(() => (key) => translations[lang][key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, toggle, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
